import {
    RATING_REQUEST,
    RATING_SUCCESS,
    RATING_FAIL,
    RATING_CLEAR_ERRORS
} from "../Constants/ratin_const";

export const rating_reducer = (
  state = {
    rating: [],
  },
  action
) => {
  switch (action.type) {
    case RATING_REQUEST:
      return {
        loading: true,
        rating: [],
      };
    case RATING_SUCCESS:
      return {
        loading: false,
        rating: action.payload.data,
      };
    case RATING_FAIL:
      return {
        loading: false,
        rating: null,
        rating_error: action.payload,
      };

    case RATING_CLEAR_ERRORS:
      return {
        ...state,
        rating_error: null,
      };
    default:
      return state;
  }
};
